import React from "react";
import { motion } from "framer-motion";
import { Briefcase, Rocket, Users, Coffee, Star, MapPin } from "lucide-react";
import Header from "../components/layout/Header";
import Footer from "../components/layout/Footer";

export default function CareersPage() {
  const fadeIn = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { duration: 0.6 }
  };

  const perks = [
    { title: "Remote Friendly", icon: Rocket },
    { title: "Great Culture", icon: Users },
    { title: "Growth Opportunities", icon: Star },
    { title: "Competitive Salary", icon: Briefcase },
  ];

  return (
    <div className="min-h-screen bg-white font-sans text-gray-900">
      <Header />

      <main>
        {/* Hero Section */}
        <section className="relative py-24 overflow-hidden bg-gray-900 text-white text-center">
          <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-br from-gray-900 via-gray-900 to-green-900/40 -z-10"></div>
          <div className="max-w-7xl mx-auto px-6">
            <motion.h1 
              {...fadeIn}
              className="text-5xl md:text-7xl font-bold mb-6 bg-clip-text text-transparent bg-gradient-to-r from-green-400 to-emerald-400"
            >
              Join Our Team
            </motion.h1>
            <p className="text-xl text-gray-400 max-w-2xl mx-auto">
              Help us build the future of e-commerce in Ethiopia. 
              We're looking for passionate people to join our mission.
            </p>
          </div>
        </section>

        {/* Content Section */}
        <section className="py-24 max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center mb-24">
            <div className="space-y-6">
              <h2 className="text-4xl font-bold">Why HuluOrder?</h2>
              <div className="w-20 h-1.5 bg-green-500 rounded-full"></div>
              <p className="text-lg text-gray-600 leading-relaxed">
                At HuluOrder, we believe in innovation, transparency, and the power of community. 
                We're building more than just a marketplace; we're building a platform that 
                empowers thousands of Ethiopians.
              </p>
              <div className="grid grid-cols-2 gap-6 pt-4">
                {perks.map((perk, i) => (
                  <div key={i} className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-green-50 rounded-lg flex items-center justify-center">
                      <perk.icon className="w-5 h-5 text-green-600" />
                    </div>
                    <span className="font-medium text-gray-700">{perk.title}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative rounded-3xl overflow-hidden shadow-2xl">
              <img 
                src="https://images.unsplash.com/photo-1552664730-d307ca884978?q=80&w=2070&auto=format&fit=crop" 
                alt="Office Life"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Open Positions */}
          <div className="text-center space-y-12">
            <h2 className="text-3xl font-bold">Open Positions</h2>
            <div className="max-w-3xl mx-auto p-12 bg-gray-50 rounded-[3rem] border border-gray-100 italic text-gray-500">
              We are currently expanding our team! While we don't have active public listings 
              at this moment, we're always looking for talent in Engineering, Marketing, 
              and Operations.
              <br /><br />
              <p className="font-bold text-gray-900 not-italic">
                Send your CV to careers@huluorder.com
              </p>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
